import api from "./api";
export interface RecruitmentRound {
  round_id: number;
  name: string;
  normalized_name: string;
  kind: "assessment" | "interview" | "final" | "offer" | "joined";
}
export interface RoundConfig {
  round_ids: number[];
  cutoff: number;
  revision: number;
}
export interface RecruitmentCandidate {
  candidate_id: number;
  registration_id: number;
  name: string;
  email: string;
  college: string;
  college_id?: number;
  score: number;
  assessment_complete: boolean;
  assessment_passed: boolean;
  eligible_round_ids: number[];
  selected_round_ids: number[];
}
export interface RecruitmentState {
  drive: {
    id: number;
    title: string;
    college_type: string;
    registration_link: string;
    college_name?: string;
    tpo_email_id?: string;
  };
  config: RoundConfig;
  rounds: RecruitmentRound[];
  candidates: RecruitmentCandidate[];
}
export interface MonitoringRow {
  drive_id: number;
  drive: string;
  college: string;
  college_type: string;
  applied: number;
  shortlisted: number;
  assessment_passed: number;
  rounds: Record<string, number>;
}
export interface MonitoringData {
  columns: RecruitmentRound[];
  rows: MonitoringRow[];
  drives: { id: number; title: string }[];
  page: number;
  total_drives: number;
  page_size: number;
}
export const recruitmentAPI = {
  rounds: () => api.get<RecruitmentRound[]>("/recruitment/rounds"),
  addRound: (name: string) =>
    api.post<RecruitmentRound>("/recruitment/rounds", { name }),
  configuration: (drive: number) =>
    api.get<{ config: RoundConfig; rounds: RecruitmentRound[] }>(
      `/recruitment/drives/${drive}/configuration`,
    ),
  get: (drive: number) =>
    api.get<RecruitmentState>(`/recruitment/drives/${drive}`),
  emailTpo: (drive: number) =>
    api.post(`/recruitment/drives/${drive}/email-tpo`),
  configure: (drive: number, config: RoundConfig, confirm_reset = false) =>
    api.put<RoundConfig>(`/recruitment/drives/${drive}`, {
      ...config,
      confirm_reset,
    }),
  select: (
    drive: number,
    round: number,
    candidate_ids: number[],
    revision: number,
  ) =>
    api.put(`/recruitment/drives/${drive}/rounds/${round}/selections`, {
      candidate_ids,
      revision,
    }),
  monitoring: (params: {
    drive_id?: number;
    college_type?: string;
    page?: number;
  }) => api.get<MonitoringData>("/recruitment/monitoring", { params }),
};
export function recruitmentError(error: any) {
  return typeof error?.response?.data?.detail === "string"
    ? error.response.data.detail
    : error?.message || "Unable to save recruitment changes";
}
